export { default } from './winstonLogger'